export default __webpack_public_path__ + "static/media/mobile-login.693a01b8.mp4";